import React, { Component } from 'react'
import { esSesionAdmin } from '../../usuario/Usuario';
import BreadCrumComponent from '../BreadCrumComponent';
import ModalLogs from './ModalLogs';
import img_success from '../../../assets/images/ilustraciones/img-success.svg';

export default class AvisoImportUsuario extends Component {

    constructor(props) {
        super(props);

        let data = props.location.state;

        this.state = {
            cantidadImportados: data?.cantidadImportados,
            ultimoUsuarioImportado: data?.ultimoUsuarioImportado,
            erroresCsv: data?.erroresCsv,
            modalError: false
        };
        this.modalRef = React.createRef();
    }

    handleFinalizar = () => {
        let url = this.setBackButton()
        this.props.history.push(url);
    }

    handleVolverMenuImp = () => {
        this.props.history.push( !esSesionAdmin() ? '/administracion/usuarios/importar' : '/admin/usuarios/importar');
    }

    handleModalError = (estado) => {
        this.setState({
            modalError: estado
        })
    }
    setBackButton = () => {
        return esSesionAdmin() ? "/admin/usuarios" : "/administracion/usuarios"
    }

    render() {
        return (
            <div className="template-base">
                <BreadCrumComponent
                    backUrl="/bandeja/pendientes"
                    breadcrumbs={
                        [
                            { label: 'Usuarios', path: this.setBackButton },
                            { label: 'Importar usuarios', path: esSesionAdmin() ? '/admin/usuarios/importar' :'/administracion/usuarios/importar' },
                            { label: 'Resultado importacion', path: '' }
                        ]
                    }
                />
                <div className="wrapperContent">
                    <div className="component-advice">
                        <div className="page-container">

                            <div className="container-flex container-md">

                                <div className="col">
                                    <h1 className="section__subtitle-sm"> ¡La Importación ha finalizado! </h1>
                                    <div className="card">
                                        <h3 className="card-title"> Aquí tienes un resumen</h3>
                                        <div className="card-info">
                                            <span className="label"> Usuarios importados </span>
                                            <span className="txt"> {this.state.cantidadImportados} </span>
                                        </div>
                                        <div className="card-info">
                                            <span className="label"> Errores registrados </span>
                                            <span className="txt"> {this.state.erroresCsv.length ?? 0} </span>
                                        </div>
                                        <div className="card-info">
                                            <span className="label"> Ultimo usuario importado </span>
                                            <span className="txt"> {this.state.ultimoUsuarioImportado ?? '--'} </span>
                                        </div>
                                        {
                                            this.state.erroresCsv &&
                                            <div className="card-actions">
                                                <button onClick={() => this.handleModalError(true)} className="btn-medium btn-primary-outline open-dialog" data-dialog="modal-logs"> Ver Log de Errores </button>
                                            </div>
                                        }
                                    </div>

                                    <div className="actions">
                                        <button onClick={this.handleFinalizar} className="btn-medium btn-primary"> Finalizar </button>
                                        <button onClick={this.handleVolverMenuImp} className="btn-medium "> Volver al menu importar </button>
                                    </div>
                                </div>

                                <div className="col">
                                    <div className="illustration">
                                        <img src={img_success} className="img-fluid" alt="accion_success" />
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                    <ModalLogs
                        ref={(ref) => (this.modalRef = ref)}
                        abierto={this.state.modalError}
                        onClose={() => this.handleModalError(false)}
                        errors={this.state.erroresCsv}
                    />
                </div>
            </div>
        )
    }
}
